import { createStore } from 'react-sweet-state';

import { DEBUG_AC_PROMPT_ENABLED } from 'src/lib/featureFlags';

import { DEFAULT_AC_PROMPT } from './const';

export const NAME = 'global-debug';

const INITIAL_STATE = {
  acPromptActive: false,
  acPrompt: DEFAULT_AC_PROMPT,
};

/**
 * Public available actions
 */
const ACTIONS = {
  resetAcPrompt:
    () =>
    ({ setState }) => {
      setState({
        acPromptActive: false,
        acPrompt: DEFAULT_AC_PROMPT,
      });
    },

  updateAcPrompt:
    (value) =>
    ({ setState }) => {
      setState({ acPrompt: value });
    },

  toggleAcPrompt:
    () =>
    ({ getState, setState }) => {
      const { acPromptActive: value } = getState();
      setState({ acPromptActive: !value });
    },

  isAcPromptActive:
    () =>
    ({ getState }) => {
      return getState().acPromptActive;
    },
  getAcPrompt:
    () =>
    ({ getState }) => {
      return getState().acPrompt;
    },
  getAcPromptIfActive:
    () =>
    ({ getState }) => {
      if (!DEBUG_AC_PROMPT_ENABLED) {
        return undefined;
      }

      const { acPromptActive, acPrompt } = getState();
      if (!acPromptActive) {
        return undefined;
      }

      return acPrompt;
    },
};

export const DebugStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: NAME,
});
